import apiConfig from '../../../../../config/api'
import { apiRequestorHelper } from '../../../../../helpers'

export default {
	items: (type, filters) => {
		return apiRequestorHelper({
			url: apiConfig.url + '/formsByTypeDeclaration/' + "KYC",
			method: 'post',
			body: filters
		})
	},
	sendReminders: (type, filters, items) => {
		return apiRequestorHelper({
			url: apiConfig.url + '/sendReminders/' + type,
			method: 'post',
			body: { ...filters, items }
		})
	},
	deleteDeclarations: (type, filters, items) => {
		return apiRequestorHelper({
			url: apiConfig.url + '/deleteDeclarations/' + type,
			method: 'post',
			body: { ...filters, items }
		})
	},
	getForm: (id) => {
		return apiRequestorHelper({
			url: apiConfig.url + '/formById/' + id,
			method: 'post',
		})
	},
	saveState: (id, statusDecl, statusComments, resendOnBoardingForm) => {
		return apiRequestorHelper({
			url: apiConfig.url + '/changeStatus',
			method: 'post',
			body: { id, statusDecl, statusComments, resendOnBoardingForm }
		})
	},
	// getFichas: (id, statusDecl, commentsStatus) => {
	// 	return apiRequestorHelper({
	// 		url: apiConfig.url + '/onb/changeStatus',
	// 		method: 'post',
	// 			body: { id, statusDecl, commentsStatus }
	// 	})
	// },
	saveComments: (formData) => {
		return apiRequestorHelper({
			url: apiConfig.url + '/saveComments',
			method: 'post',
		body: formData
		})
	},
	getFicha: (id) => {
		return apiRequestorHelper({
			url: apiConfig.url + '/onb/ficha/' + id,
			method: 'get'
		})
	}
}
